import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponentComponent } from './loader-component/loader-component.component'

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [LoaderComponentComponent],
  exports: [LoaderComponentComponent]
})
export class LoaderModule { }
